/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Row_Impact_BodyInputs */



/**
* | output |
* | --- |
* | "Every mark reads the days after it against your server's usual swing." |
*
* @param {Products_Row_Impact_BodyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_row_impact_body = /** @type {((inputs?: Products_Row_Impact_BodyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Row_Impact_BodyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Каждая отметка сравнивает дни после неё с обычным для вашего сервера разбросом.")
	return /** @type {LocalizedString} */ ("Every mark reads the days after it against your server's usual swing.")
});